export default __webpack_public_path__ + "1c4ad6dd7d78a10caf04672b17350659.svg";